<template>
    <b-container>
        <h1>404 Page Not Found</h1>
        <h2>We couldn't find the page you're looking for.</h2>
    </b-container>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style>
h1, h2 {
    font-family: 'Rajdhani', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue